import React from "react"

function Smile({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_10_418"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="8"
        y="8"
        width="20"
        height="20"
      >
        <path d="M28 8H8V28H28V8Z" fill="white" />
      </mask>
      <g mask="url(#mask0_10_418)">
        <path
          d="M18 26.3332C22.6024 26.3332 26.3333 22.6022 26.3333 17.9998C26.3333 13.3975 22.6024 9.6665 18 9.6665C13.3976 9.6665 9.66666 13.3975 9.66666 17.9998C9.66666 22.6022 13.3976 26.3332 18 26.3332Z"
          stroke="#003E4C"
          strokeWidth="1"
        />
        <path
          d="M15.5 21.3335C16.2086 21.8587 17.0705 22.1668 18 22.1668C18.9295 22.1668 19.7913 21.8587 20.5 21.3335"
          stroke="#003E4C"
          strokeWidth="1"
          strokeLinecap="round"
        />
        <path
          d="M21.3333 16.75C21.3333 17.4403 20.9603 18 20.5 18C20.0398 18 19.6667 17.4403 19.6667 16.75C19.6667 16.0596 20.0398 15.5 20.5 15.5C20.9603 15.5 21.3333 16.0596 21.3333 16.75Z"
          fill="#003E4C"
        />
        <path
          d="M15.5 18C15.9602 18 16.3333 17.4404 16.3333 16.75C16.3333 16.0596 15.9602 15.5 15.5 15.5C15.0398 15.5 14.6667 16.0596 14.6667 16.75C14.6667 17.4404 15.0398 18 15.5 18Z"
          fill="#003E4C"
        />
      </g>
    </svg>
  )
}
export default Smile
